/**
 * Reduce a URL to page identity: origin + pathname only. Drops the query
 * string, hash, and any userinfo — they can carry customer PII (search terms,
 * emails, tokens, credentials), and analytics events land in a durable,
 * non-GDPR-erased warehouse, so only page identity may be emitted. Returns ''
 * for a URL that can't be parsed (fail closed — never emit a raw URL).
 */
export function toAnalyticsPageUrl(rawUrl: string): string {
  try {
    const { origin, pathname } = new URL(rawUrl);
    return `${origin}${pathname.replace(/\/+$/, '') || '/'}`;
  } catch {
    return '';
  }
}

/**
 * Page identity of the current location, for stamping on analytics events.
 * See {@link toAnalyticsPageUrl} for the PII policy.
 */
export function getAnalyticsPageUrl(): string {
  if (typeof window === 'undefined') {
    return '';
  }
  return toAnalyticsPageUrl(window.location.href);
}
